import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {TitleService} from '../../services/title.service';
import {StatusBannerService} from '../../services/status-banner.service';
import {MenuService} from '../../services/menu.service';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.css']
})
export class BaseComponent implements OnInit {
  constructor(
    public titleService: TitleService,
    public statusBannerService: StatusBannerService,
    public menuService: MenuService,
    private location: Location
  ) {}

  ngOnInit(): void {
  }

  back(): void {
    this.location.back();
  }
}
